import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
    selector: 'app-analysis-options',
    templateUrl: './analysis-options.component.html',
    styleUrls: ['./analysis-options.component.scss'],
})
export class AnalysisOptionsComponent implements OnInit, OnChanges {
    @Output() analysisOptionIdChange = new EventEmitter<number>();
    @Output() selectedSummaryStatisticsIdChange = new EventEmitter<string>();

    @Input() analysisOptions: AnalysisOption[] = [
        {
            id: 1,
            name: 'Samples',
        },
        {
            id: 2,
            name: 'Measurements',
        },
    ];

    @Input() summaryStatistics: SummaryStatistic[] = [
        {
            id: 'meanActivity',
            name: 'Arithmetic Mean',
        },
        {
            id: 'medianActivity',
            name: 'Median',
        },
        {
            id: 'geometricMean',
            name: 'Geometric Mean',
        },
        {
            id: 'maxActivity',
            name: 'Maximum',
        },
    ];

    get summaryStatisticFilteredList(): SummaryStatistic[] {
        if (this.selectedNuclideId === 3) {
            return this.summaryStatistics.filter((statistic) => statistic.id !== 'geometricMean');
        }
        return this.summaryStatistics;
    }

    @Input() analysisOptionId: number = 1;
    @Input() hideMeasurementOption: boolean = false;
    @Input() selectedSummaryStatisticsId: string = 'meanActivity';
    @Input() selectedNuclideId: number | undefined;

    constructor() {}

    ngOnInit(): void {}

    ngOnChanges(): void {
        // if c-14 and geometric mean is selected, change to max
        if (this.selectedNuclideId === 3 && this.selectedSummaryStatisticsId === 'geometricMean') {
            this.selectedSummaryStatisticsId = 'meanActivity';
            this.selectedSummaryStatisticsIdChange.emit(this.selectedSummaryStatisticsId);
        }
    }

    onUserAnalysisOptionChange(optionId: number): void {
        this.analysisOptionId = optionId;
        this.analysisOptionIdChange.emit(optionId);
    }

    onSummaryStatisticsChange(statisticId: string): void {
        this.selectedSummaryStatisticsIdChange.emit(statisticId);
    }
}

type AnalysisOption = {
    id: number;
    name: string;
};

type SummaryStatistic = {
    id: string;
    name: string;
};
